import i18n from "@/lib/i18n/i18n"

// Notice codes from the routing service → translation keys. The message is
// translated when the error is parsed.
const ROUTE_ERROR_KEYS = {
  noRouteFound: "maps.routeErrors.noRouteFound",
  waypointNotReachable: "maps.routeErrors.waypointNotReachable",
  violatesVehicleRestriction: "maps.routeErrors.violatesVehicleRestriction",
  routeCalculationFailed: "maps.routeErrors.routeCalculationFailed",
  tooManyWaypoints: "maps.routeErrors.tooManyWaypoints",
  invalidWaypoints: "maps.routeErrors.invalidWaypoints",
  incompatibleParameters: "maps.routeErrors.incompatibleParameters",
  avoidAreasTooLarge: "maps.routeErrors.avoidAreasTooLarge",
  unmatchedWaypoints: "maps.routeErrors.unmatchedWaypoints",
  accessNotAllowed: "maps.routeErrors.accessNotAllowed",
  notEnoughDetail: "maps.routeErrors.notEnoughDetail",
} as const

const defaultRouteErrorMessage = (): string =>
  i18n.t("maps.routeErrors.default")

const routeErrorMessage = (code: string): string =>
  Object.prototype.hasOwnProperty.call(ROUTE_ERROR_KEYS, code)
    ? i18n.t(ROUTE_ERROR_KEYS[code as keyof typeof ROUTE_ERROR_KEYS])
    : defaultRouteErrorMessage()

export const parseRouteErrors = (err: unknown): string[] => {
  const rawText =
    err != null &&
    typeof (err as Record<string, unknown>).text === "string" &&
    ((err as Record<string, unknown>).text as string).length > 0
      ? ((err as Record<string, unknown>).text as string)
      : null

  if (rawText) {
    try {
      const parsed = JSON.parse(rawText)
      const notices: { code?: string }[] = parsed?.notices ?? []
      const messages = notices
        .map((n) => (n.code ? routeErrorMessage(n.code) : null))
        .filter((m): m is string => m !== null)
      if (messages.length > 0) return messages
    } catch {
      // not JSON — fall through to default
    }
  }

  return [defaultRouteErrorMessage()]
}
